import { createActions } from "redux-actions";

/**
 * The constants here need to match the related actions. The actions
 * themselves are CONSTANT_CASED, but the related constants are camelCased
 * based on the _, so CONSTANT_CASED becomes constantCased, and something
 * like SOME_DUMB_THING is someDumbThing. Kinda dumb, but w/e.
 */
export const {
    candidateFetchProfile,
    candidateSetProfileData,

    candidateIncrAnswerCount,
    candidateSetAutoApply,
} = createActions(
    "CANDIDATE_FETCH_PROFILE",
    "CANDIDATE_SET_PROFILE_DATA",

    "CANDIDATE_INCR_ANSWER_COUNT",
    "CANDIDATE_SET_AUTO_APPLY",
);
